import { DetailCardCoach } from '../../../../ui/components';
import { DynamicObjectInterface } from '../../../../sdk/type';
import { GetColumnsType } from '../../../../ui/components/TableContainer/types/propsTypes';

export const getCoachListConfig: GetColumnsType = () => [
  {
    key: '',
    width: 100,
    sortable: true,
    render: (object: DynamicObjectInterface) => {
      return <DetailCardCoach {...(object as DynamicObjectInterface)} />;
    },
  },
];
